(function () {
  function init() {
    var grid = document.querySelector('[data-blog-grid]');
    var paginationEl = document.querySelector('[data-blog-pagination]');
    if (!grid || !paginationEl) return;

    var perPage = parseInt(grid.dataset.perPage, 10);
    var articles = Array.from(grid.querySelectorAll('[data-article-index]'));
    var total = articles.length;
    if (total === 0) return;

    var totalPages = Math.ceil(total / perPage);
    var labelPrev = paginationEl.dataset.prev || '';
    var labelNext = paginationEl.dataset.next || '';

    function getPage() {
      var params = new URLSearchParams(window.location.search);
      var pg = parseInt(params.get('pg') || '1', 10);
      return Math.max(1, Math.min(pg, totalPages));
    }

    function buildUrl(page) {
      var params = new URLSearchParams(window.location.search);
      if (page === 1) {
        params.delete('pg');
      } else {
        params.set('pg', String(page));
      }
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    function showPage(page) {
      var start = (page - 1) * perPage;
      var end = start + perPage;
      articles.forEach(function (article, i) {
        article.style.display = (i >= start && i < end) ? '' : 'none';
      });
      renderPagination(page);
    }

    function renderPagination(currentPage) {
      if (totalPages <= 1) {
        paginationEl.innerHTML = '';
        return;
      }

      var prevUrl = currentPage > 1 ? buildUrl(currentPage - 1) : null;
      var nextUrl = currentPage < totalPages ? buildUrl(currentPage + 1) : null;
      var html = '<nav class="pagination-custom">';

      if (prevUrl) {
        html += '<a class="pagination-custom__prev" href="' + prevUrl + '"><span>' + labelPrev + '</span></a>';
      } else {
        html += '<span class="pagination-custom__prev is-hidden"><span>' + labelPrev + '</span></span>';
      }

      html += '<div class="pagination-custom__inner">';
      for (var p = 1; p <= totalPages; p++) {
        var delta = Math.abs(p - currentPage);
        if (p === 1 || p === totalPages || delta <= 1) {
          if (p === currentPage) {
            html += '<span class="pagination-custom__page pagination-custom__page--active">' + p + '</span>';
          } else {
            html += '<a href="' + buildUrl(p) + '" class="pagination-custom__page">' + p + '</a>';
          }
        } else if (delta === 2) {
          html += '<span class="pagination-custom__sep">&hellip;</span>';
        }
      }
      html += '</div>';

      if (nextUrl) {
        html += '<a class="pagination-custom__next" href="' + nextUrl + '"><span>' + labelNext + '</span></a>';
      } else {
        html += '<span class="pagination-custom__next is-hidden"><span>' + labelNext + '</span></span>';
      }

      html += '</nav>';
      paginationEl.innerHTML = html;

      paginationEl.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var url = new URL(a.href);
          var pg = parseInt(url.searchParams.get('pg') || '1', 10);
          navigateTo(pg);
        });
      });
    }

    function navigateTo(page) {
      showPage(page);
      history.pushState({ pg: page }, '', buildUrl(page));
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    window.addEventListener('popstate', function () {
      showPage(getPage());
    });

    showPage(getPage());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
